import { faX } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, useTheme } from '@mui/material/styles';
import { useEffect } from 'react';

import Input from '~/common/components/Inputs/Input';
import InputGroup from '~/common/components/Inputs/InputGroup';
import InputRightElement from '~/common/components/Inputs/InputRightElement';
import { useSelectedAlert } from '~/stores/navigationStore';
import { useNavSearchStore } from '~/stores/useNavSearchStore';

const ClearButton = styled('button')`
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.gray[600]};
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`;

const SearchInputWrapper = styled('div')`
  padding: 0.5rem;
  background-color: white;
`;

export function SearchInput() {
  const { searchQuery, setSearchQuery, clearSearchQuery } = useNavSearchStore();
  const categoryId = useSelectedAlert((alert) => alert?.ruleCategoryId);

  useEffect(() => {
    clearSearchQuery();
  }, [categoryId, clearSearchQuery]);

  const isEmpty = searchQuery === '';

  const theme = useTheme();

  return (
    <SearchInputWrapper>
      <InputGroup>
        <Input
          placeholder="Search pages"
          sx={{
            borderColor: theme.palette.gray[300],
            '&::placeholder': {
              color: theme.palette.gray[600],
            },
            '&:focus': {
              borderColor: theme.palette.gray[600],
              outline: 'none',
              boxShadow: 'none',
            },
          }}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          aria-label="Search pages"
        />
        {!isEmpty && (
          <InputRightElement
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderLeft: 'none',
              borderTopRightRadius: '6px',
              borderBottomRightRadius: '6px',
            }}
          >
            <ClearButton
              type="button"
              aria-label="Clear search"
              onClick={clearSearchQuery}
            >
              <FontAwesomeIcon icon={faX} />
            </ClearButton>
          </InputRightElement>
        )}
      </InputGroup>
    </SearchInputWrapper>
  );
}
